import { atom } from 'recoil';
import { ICompetencia } from '../../commons/types/crm';


export const competenciaAtom = atom<ICompetencia[]>({
  key: 'configCompetencias',
  default: [] as ICompetencia[],
});
